export type DimensionsSpecificationRequestBody = {
  /**
   * Vehicle width in mm
   */
  width?: number | null;
  /**
   * Vehicle height in mm
   */
  height?: number | null;
  /**
   * Vehicle length in mm
   */
  length?: number | null;
};
